import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CreateHelpInfoParams, HelpInfosFilter } from 'types';
import { Link, match, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import FormHelpInfo from 'components/templates/form-help-info';
import Card from 'components/molecules/card';
import {
  helpInfosSelectors,
  helpInfoActions,
  helpInfoSelectors,
  ClearStateSliceActions,
  SituationsCategorySelectors,
  SituationsCategoryActions,
  ServiceTypesSelectors,
} from 'common/config/store';
import history from 'app-router/history';

const Wrapper = styled.div`
  margin: 5px;
`;

const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const HelpInfoPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { state: locationFilterValues } = useLocation<HelpInfosFilter>();

  const [longMessageBrut, setLongMessageBrut] = useState('');

  const status = useSelector(helpInfoSelectors.statusSelector);
  const error = useSelector(helpInfoSelectors.errorSelector);
  const helpInfos = useSelector(helpInfosSelectors.dataSelector);
  const situationsCategory = useSelector(SituationsCategorySelectors.situationsCategorySelector);
  const serviceTypes = useSelector(ServiceTypesSelectors.serviceTypesSelector);

  const { id } = props.match.params;
  const helpInfo = id ? helpInfos?.result?.find((hi) => hi.id.toString() === id) : undefined;

  useEffect(() => {
    dispatch(SituationsCategoryActions.fetchSituationsCategory());
  }, [dispatch]);

  useEffect(() => {
    if (helpInfo && helpInfo?.longMessageBrut) {
      setLongMessageBrut(helpInfo?.longMessageBrut);
    }
  }, [helpInfo]);

  useEffect(() => {
    dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'HelpInfo' }));

    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'HelpInfo', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'HelpInfo', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onSubmitHandler = useCallback(
    (values: Omit<CreateHelpInfoParams, 'longMessageBrut'>) => {
      if (helpInfo?.id) {
        dispatch(
          helpInfoActions.updateHelpInfo(
            {
              id: helpInfo.id,
              ...values,
              longMessageBrut,
            },
            (result) => {
              if (!result.cancelled && !result.error) {
                history.push('/help-infos', locationFilterValues);
              }
            }
          )
        );
      } else {
        dispatch(
          helpInfoActions.createHelpInfo(
            {
              ...values,
              longMessageBrut,
            },
            (result) => {
              if (!result.cancelled && !result.error) {
                history.push('/help-infos');
              }
            }
          )
        );
      }
    },
    [dispatch, longMessageBrut, helpInfo, locationFilterValues]
  );

  const title = id ? t('HelpInfoPage', 'HELP_INFO_UPDATE') : t('HelpInfoPage', 'HELP_INFO_CREATE');
  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link
            to={{
              pathname: '/help-infos',
              state: locationFilterValues,
            }}
          >
            {t('HelpInfoPage', 'HELP_INFOS_BACK')}
          </Link>
        </StyledBreadcrumbWrapper>

        <Card title={title} width={600}>
          <FormHelpInfo
            onSubmit={onSubmitHandler}
            helpInfo={helpInfo || undefined}
            setLongMessageBrut={setLongMessageBrut}
            status={status}
            error={error}
            situationsCategory={situationsCategory}
            serviceTypes={serviceTypes}
          />
        </Card>
      </Wrapper>
    </div>
  );
};

export default HelpInfoPage;
